<template>
  <transition name="fade">
    <div v-if="showModal" class="fixed inset-0 w-full h-screen flex items-center justify-center bg-semi-75 fixed"
      @click.self="close">
      <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-75" @click.self="close"></div>
      <div class="relative w-full max-w-2xl bg-white shadow-lg rounded-lg p-8">
        <h1 class="font-bold"><slot name="header"/></h1>
        <button aria-label="close"
                class="absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4"
                @click.prevent="close">
          ×
        </button>
        <div>
          <slot />
        </div>
        <div id="modalDialogFooter" class="p-4">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      showModal: false
    }
  },

  methods: {
    open () {
      this.showModal = true
    },

    close () {
      this.showModal = false
    }
  }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
